import * as classnames from 'classnames';
import * as React from 'react';
import styled from 'styled-components';
import { Star } from './Star';
import { observer } from 'mobx-react';

export interface IStarsSelector {
    className?: string;
    starsArray: number[];
    selectedRating: number;
    clickHandler(index: number): void;
}

const StarsMainWrapper = styled.div`
    white-space: nowrap;
`;

export const StarsSelector = observer((props: IStarsSelector) => {
    const classNames = classnames('elc-stars-selector', 'js-stars-selector', props.className);

    return (
        <StarsMainWrapper className={classNames}>
            {props.starsArray.map((_, index) => (
                <Star
                    key={index + 1}
                    index={index + 1}
                    selected={props.selectedRating > index}
                    clickHandler={props.clickHandler}
                />
            ))}
        </StarsMainWrapper>
    );
});
